import { render, staticRenderFns } from "./ContactsSearch.vue?vue&type=template&id=2b70ae62"
import script from "./ContactsSearch.vue?vue&type=script&lang=js"
export * from "./ContactsSearch.vue?vue&type=script&lang=js"
import style0 from "./ContactsSearch.vue?vue&type=style&index=0&id=2b70ae62&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports